export AppLink from './AppLink';



// WEBPACK FOOTER //
// ./src/frontend/modules/routing/containers/index.js